import { proxy } from '@/utils'

import render from './render'

export default {
  name: 'Title',

  mixins: [ proxy() ],

  props: {
    disabled: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      showDialog: false
    }
  },

  render
}
